export default __webpack_public_path__ + "static/media/about-organization.4ab76410.png";